import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import MuiSnackbar from '@mui/material/Snackbar'
import { Slide, Box } from '@mui/material'
import type { SlideProps } from '@mui/material/Slide'

function SlideTransition(props: TransitionProps) {
  return <Slide {...props} direction="up" />
}

type TransitionProps = Omit<SlideProps, 'direction'>

const useStyles = makeStyles()((theme: Theme) => ({
  box: {
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.background.paper,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
  },
  error: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
  },
}))

export type SnackbarProps = {
  /**
   * 開閉状態
   */
  open: boolean
  /**
   * 閉じる時に発火する関数
   */
  handleClose: () => void
  /**
   * 表示されるコンテンツ
   */
  message: any
  /**
   * 自動で消える時間ms
   */
  time?: number | null
  /**
   *
   */
  error?: boolean
}

const Snackbar: React.VFC<SnackbarProps> = ({
  open,
  message,
  handleClose,
  time = 4000,
  error,
}: SnackbarProps) => {
  const { classes, cx } = useStyles()

  return (
    <MuiSnackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={time}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={message}
    >
      <Box className={cx(classes.box, error && classes.error)} boxShadow={3}>
        {message}
      </Box>
    </MuiSnackbar>
  )
}

export default Snackbar
